// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class LetterspacingAttributor extends StyleAttributor {
    public add(node: HTMLElement, value: any) {
        // Exclude <li> tags to prevent letterspacing from affecting numbers/bullets in text lists
        if (!super.canAdd(node, value) || node.tagName === 'LI') {
            return false;
        }
        // eslint-disable-next-line no-param-reassign
        node.dataset.letterspacing = value;

        return super.add(node, value);
    }

    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): any {
        if (!node.dataset.letterspacing) {
            return '';
        }
        return node.dataset.letterspacing;
    }
}

// @ts-ignore
export default new LetterspacingAttributor('letterspacing', 'letter-spacing', {
    scope: Scope.INLINE,
});
// @ts-ignore
export const BlockLetterspacingAttributor = new LetterspacingAttributor('blockLetterspacing', 'letter-spacing', { scope: Scope.BLOCK });

